import Vue from 'vue'
import store from '@/store/index';
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AllDay from '../views/AllDay.vue'
import Event from '../views/Event.vue'
import Unsubscribe from '../views/Unsubscribe.vue'
import AllEvents from '../views/AllEvents.vue'
import ForJournalists from '../views/ForJournalists.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/unsubscribe',
        name: 'Unsubscribe',
        component: Unsubscribe
    },
    {
        path: '/allevents',
        name: 'AllEvents',
        component: AllEvents
    },
    {
        path: '/forjournalists',
        name: 'ForJournalists',
        component: ForJournalists
    },
    {
        path: '/:date/',
        name: 'AllDay',
        component: AllDay
    },
    {
        path: '/:date/:id',
        name: 'Event',
        component: Event
    },
]

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(from, to) {
        if (from.name !== to.name) {
            return {x: 0, y: 0}
        }
    }
})
router.beforeEach(async (to, from, next) => {
    if (!store.state.calendar) {
        await store.dispatch('fetchCalendar');
    }
    next()
});
export default router
